import styled from 'styled-components';

export const Header = styled.div`
    background-color: #fff;
    box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.1);
    position: relative;
    z-index: 7;
`;